module.exports = __webpack_public_path__ + "img/tandika-logo.25126f4e.png";